// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Each tone defines its three colours; variants pick which to use */
.cbd-primary { --cbd-fg: var(--cui-primary); --cbd-bg: var(--cui-primary-soft); --cbd-border: var(--cui-primary-border); }
.cbd-success { --cbd-fg: var(--cui-success); --cbd-bg: var(--cui-success-soft); --cbd-border: var(--cui-success-border); }
.cbd-danger  { --cbd-fg: var(--cui-danger);  --cbd-bg: var(--cui-danger-soft);  --cbd-border: var(--cui-danger-border); }
.cbd-warning { --cbd-fg: var(--cui-warning); --cbd-bg: var(--cui-warning-soft); --cbd-border: var(--cui-warning-border); }
.cbd-info    { --cbd-fg: var(--cui-info);    --cbd-bg: var(--cui-info-soft);    --cbd-border: var(--cui-info-border); }
.cbd-neutral { --cbd-fg: var(--cui-text-muted); --cbd-bg: var(--cui-bg-hover); --cbd-border: var(--cui-border); }

.cbd-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  border: 1px solid transparent;
  border-radius: 999px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  vertical-align: middle;
}

.cbd-md {
  padding: 4px 10px;
  font-size: 11.5px;
}

.cbd-sm {
  padding: 2px 8px;
  font-size: 10.5px;
}

.cbd-soft {
  background: var(--cbd-bg);
  color: var(--cbd-fg);
}

.cbd-outline {
  background: var(--cui-bg);
  border-color: var(--cbd-border);
  color: var(--cbd-fg);
}

.cbd-solid {
  background: var(--cbd-fg);
  color: var(--cui-text-on-primary);
}

.cbd-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.cbd-dot {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
  background: currentColor;
}

.cbd-icon {
  display: inline-flex;
  flex-shrink: 0;
}

.cbd-icon svg {
  width: 12px;
  height: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomBadge/CustomBadge.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE,eAAe,4BAA4B,EAAE,iCAAiC,EAAE,uCAAuC,EAAE;AACzH,eAAe,4BAA4B,EAAE,iCAAiC,EAAE,uCAAuC,EAAE;AACzH,eAAe,2BAA2B,GAAG,gCAAgC,GAAG,sCAAsC,EAAE;AACxH,eAAe,4BAA4B,EAAE,iCAAiC,EAAE,uCAAuC,EAAE;AACzH,eAAe,yBAAyB,KAAK,8BAA8B,KAAK,oCAAoC,EAAE;AACtH,eAAe,+BAA+B,EAAE,6BAA6B,EAAE,+BAA+B,EAAE;;AAEhH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Each tone defines its three colours; variants pick which to use */\n.cbd-primary { --cbd-fg: var(--cui-primary); --cbd-bg: var(--cui-primary-soft); --cbd-border: var(--cui-primary-border); }\n.cbd-success { --cbd-fg: var(--cui-success); --cbd-bg: var(--cui-success-soft); --cbd-border: var(--cui-success-border); }\n.cbd-danger  { --cbd-fg: var(--cui-danger);  --cbd-bg: var(--cui-danger-soft);  --cbd-border: var(--cui-danger-border); }\n.cbd-warning { --cbd-fg: var(--cui-warning); --cbd-bg: var(--cui-warning-soft); --cbd-border: var(--cui-warning-border); }\n.cbd-info    { --cbd-fg: var(--cui-info);    --cbd-bg: var(--cui-info-soft);    --cbd-border: var(--cui-info-border); }\n.cbd-neutral { --cbd-fg: var(--cui-text-muted); --cbd-bg: var(--cui-bg-hover); --cbd-border: var(--cui-border); }\n\n.cbd-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.cbd-md {\n  padding: 4px 10px;\n  font-size: 11.5px;\n}\n\n.cbd-sm {\n  padding: 2px 8px;\n  font-size: 10.5px;\n}\n\n.cbd-soft {\n  background: var(--cbd-bg);\n  color: var(--cbd-fg);\n}\n\n.cbd-outline {\n  background: var(--cui-bg);\n  border-color: var(--cbd-border);\n  color: var(--cbd-fg);\n}\n\n.cbd-solid {\n  background: var(--cbd-fg);\n  color: var(--cui-text-on-primary);\n}\n\n.cbd-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cbd-dot {\n  width: 6px;\n  height: 6px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.cbd-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.cbd-icon svg {\n  width: 12px;\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
